import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryDispatchListView from 'src/sections/stationery-dispatch/view/stationery-dispatch-list-view';

export default function StationeryDispatchListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Stationery Dispatch</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_STATIONERY_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryDispatchListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
